module.exports = __webpack_public_path__ + "img/ssb_menu11.3215c8d5.png";